import React from 'react'
import styled from 'styled-components'
import { connect, ConnectedProps } from 'react-redux'
import { setLanguage, Lang } from './../../reducers/uiReducer'
import { ReduxState } from '../../types'
import { slovenianLanguageEnabled } from './../../constants'

const StyledButton = styled.div`
  pointer-events: auto;
  cursor: pointer;
  padding: 3px;
  font-size: 20px;
  color: black;
`

const ToggleLanguageButton = (props: PropsFromRedux) => {
  return (
    <StyledButton
      data-cy="toggle-lang-button"
      style={{ cursor: slovenianLanguageEnabled ? 'pointer' : 'default' }}
      onClick={() => {
        if (slovenianLanguageEnabled) {
          props.setLanguage(props.lang === Lang.SL ? Lang.EN : Lang.SL)
        }
      }}
    >
      {slovenianLanguageEnabled ? (props.lang === Lang.SL ? 'EN' : 'SL') : 'EN'}
    </StyledButton>
  )
}

const mapStateToProps = (state: ReduxState) => ({
  lang: state.ui.lang,
})

const connector = connect(mapStateToProps, { setLanguage })
type PropsFromRedux = ConnectedProps<typeof connector>
export default connector(ToggleLanguageButton)
